import { useState } from "react";
import type { Certification } from "@/data/certifications";

interface Props {
  cert: Certification;
  className?: string;
}

export function CertificationLogo({ cert, className = "" }: Props) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div className={`flex items-center justify-center px-3 py-2 text-center ${className}`}>
        <span className="font-italic-serif italic text-brand-warm-gray text-xs md:text-sm leading-tight">
          {cert.name}
        </span>
      </div>
    );
  }

  return (
    <img
      src={cert.logoUrl}
      alt={`Logo ${cert.name}`}
      onError={() => setErrored(true)}
      loading="lazy"
      decoding="async"
      className={`object-contain mx-auto ${className}`}
    />
  );
}